module.exports = __webpack_public_path__ + "static/PhoneFieldsLeafs-5b10ae4670450758cc8d14a08e91db38.png";